module.exports = __webpack_public_path__ + "static/img/smiling_imp.920cef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/smiling_imp.png
// module id = Sl2h
// module chunks = 0